import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13.333 5.833c0-.775 0-1.162-.085-1.48a2.5 2.5 0 0 0-1.767-1.768C11.161 2.5 10.775 2.5 10 2.5c-.776 0-1.163 0-1.481.085a2.5 2.5 0 0 0-1.768 1.768c-.085.318-.085.705-.085 1.48M4.333 17.5h11.334c.933 0 1.4 0 1.756-.182.314-.16.569-.414.729-.728.181-.357.181-.823.181-1.757V8.5c0-.933 0-1.4-.181-1.757a1.67 1.67 0 0 0-.729-.728c-.356-.182-.823-.182-1.756-.182H4.333c-.933 0-1.4 0-1.756.182-.314.16-.569.415-.729.728-.181.357-.181.824-.181 1.757v6.333c0 .934 0 1.4.181 1.757.16.314.415.569.729.728.356.182.823.182 1.756.182"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }